(function () {
  "use strict";

  const CHAT_COPY = Object.freeze({
    en: { mini: "How can we help?", name: "CarOptions customer service", intro: "Hello! Do you have a question about your car, order or installation? Send us a message and our team will be happy to help.", online: "Online", offline: "Offline", typing: "is typing…", placeholder: "Type your message…", ready: "How can we help you today?", away: "Leave your question here. We will reply as soon as possible." },
    de: { mini: "Wie können wir helfen?", name: "CarOptions Kundenservice", intro: "Hallo! Haben Sie eine Frage zu Ihrem Fahrzeug, Ihrer Bestellung oder der Installation? Schreiben Sie uns – unser Team hilft Ihnen gern weiter.", online: "Online", offline: "Offline", typing: "schreibt…", placeholder: "Nachricht eingeben…", ready: "Wie können wir Ihnen heute helfen?", away: "Hinterlassen Sie hier Ihre Frage. Wir antworten so bald wie möglich." },
    es: { mini: "¿Cómo podemos ayudarte?", name: "Atención al cliente de CarOptions", intro: "¡Hola! ¿Tienes alguna pregunta sobre tu coche, tu pedido o la instalación? Escríbenos y nuestro equipo te ayudará encantado.", online: "En línea", offline: "Desconectado", typing: "está escribiendo…", placeholder: "Escribe tu mensaje…", ready: "¿En qué podemos ayudarte hoy?", away: "Déjanos tu consulta y te responderemos lo antes posible." },
    fr: { mini: "Comment vous aider ?", name: "Service client CarOptions", intro: "Bonjour ! Une question sur votre véhicule, votre commande ou l’installation ? Écrivez-nous, notre équipe se fera un plaisir de vous aider.", online: "En ligne", offline: "Hors ligne", typing: "écrit…", placeholder: "Saisissez votre message…", ready: "Comment pouvons-nous vous aider aujourd’hui ?", away: "Laissez-nous votre question. Nous vous répondrons dans les meilleurs délais." },
    it: { mini: "Come possiamo aiutarti?", name: "Servizio clienti CarOptions", intro: "Ciao! Hai una domanda sulla tua auto, sul tuo ordine o sull’installazione? Scrivici: il nostro team sarà felice di aiutarti.", online: "Online", offline: "Offline", typing: "sta scrivendo…", placeholder: "Scrivi il tuo messaggio…", ready: "Come possiamo aiutarti oggi?", away: "Lascia qui la tua domanda. Ti risponderemo il prima possibile." },
    pl: { mini: "Jak możemy pomóc?", name: "Obsługa klienta CarOptions", intro: "Dzień dobry! Masz pytanie dotyczące samochodu, zamówienia lub montażu? Napisz do nas — chętnie pomożemy.", online: "Online", offline: "Offline", typing: "pisze…", placeholder: "Wpisz wiadomość…", ready: "W czym możemy dziś pomóc?", away: "Zostaw pytanie. Odpowiemy tak szybko, jak to możliwe." },
    sv: { mini: "Hur kan vi hjälpa?", name: "CarOptions kundservice", intro: "Hej! Har du frågor om bilen, beställningen eller installationen? Skriv till oss så hjälper vårt team dig gärna.", online: "Online", offline: "Offline", typing: "skriver…", placeholder: "Skriv ditt meddelande…", ready: "Hur kan vi hjälpa dig i dag?", away: "Lämna din fråga här. Vi svarar så snart som möjligt." },
    da: { mini: "Hvordan kan vi hjælpe?", name: "CarOptions kundeservice", intro: "Hej! Har du spørgsmål om bilen, ordren eller monteringen? Skriv til os, så hjælper vores team dig gerne.", online: "Online", offline: "Offline", typing: "skriver…", placeholder: "Skriv din besked…", ready: "Hvordan kan vi hjælpe dig i dag?", away: "Skriv dit spørgsmål her. Vi svarer hurtigst muligt." },
    fi: { mini: "Kuinka voimme auttaa?", name: "CarOptions-asiakaspalvelu", intro: "Hei! Onko sinulla kysyttävää autosta, tilauksesta tai asennuksesta? Lähetä meille viesti, niin autamme mielellämme.", online: "Tavoitettavissa", offline: "Poissa", typing: "kirjoittaa…", placeholder: "Kirjoita viesti…", ready: "Kuinka voimme auttaa tänään?", away: "Jätä kysymyksesi tähän. Vastaamme mahdollisimman pian." },
    no: { mini: "Hvordan kan vi hjelpe?", name: "CarOptions kundeservice", intro: "Hei! Har du spørsmål om bilen, bestillingen eller monteringen? Skriv til oss, så hjelper teamet vårt deg gjerne.", online: "Online", offline: "Offline", typing: "skriver…", placeholder: "Skriv meldingen din…", ready: "Hvordan kan vi hjelpe deg i dag?", away: "Legg igjen spørsmålet ditt her. Vi svarer så snart som mulig." }
  });

  const PHONE_BY_LOCALE = Object.freeze({
    de: "498926207087",
    it: "390550296592",
    es: "34910626563",
    fr: "33974309240"
  });
  const VERIFIED_FALLBACK_PHONE = "31850606177";

  function localeCode() {
    const raw = (document.documentElement.lang || "en").toLowerCase();
    const short = raw.split("-")[0];
    return CHAT_COPY[short] ? short : "en";
  }

  function whatsappNumber() {
    return PHONE_BY_LOCALE[localeCode()] || VERIFIED_FALLBACK_PHONE;
  }

  function isWithinOpeningHours() {
    const hour = new Date().getHours();
    return hour >= 8 && hour < 23;
  }

  function initChat() {
    if (!document.querySelector("#vue-chat") || typeof Vue === "undefined") return;
    const copy = Object.assign({}, CHAT_COPY[localeCode()], {
      close: localeCode() === "de" ? "Schließen" : "Close",
      send: localeCode() === "de" ? "Nachricht senden" : "Send"
    });

    new Vue({
      el: "#vue-chat",
      template: `
        <div class="vue-chat" v-if="active">
          <button v-if="!chatOpen" type="button" :class="miniMessage ? 'vue-chat__cloud active' : 'vue-chat__cloud'" @click="chatOpen = 1" :aria-label="copy.mini"><span class="vue-chat__icon"></span></button>
          <div :class="miniMessage ? 'vue-chat__slide active' : 'vue-chat__slide'"><span>{{ copy.mini }}</span></div>
          <div :class="megaMessage ? 'vue-chat__slide--mega active' : 'vue-chat__slide--mega'">
            <div class="vue-chat__box__chat">
              <button type="button" class="vue-chat__slide--mega__close" @click="megaMessage = 0" :aria-label="copy.close">+</button>
              <div class="vue-chat__box__chat__header">
                <div class="vue-chat__box__avatar__image"><img src="" alt=""></div>
                <div class="vue-chat__box__chat__header__sub"><h3>{{ copy.name }}</h3><span class="vue-chat__box__state">{{ statusText }}</span></div>
              </div>
              <p>{{ copy.intro }}</p>
            </div>
            <div class="vue-chat__mega-sub"><span class="mega-time">{{ timeMega }}</span><div class="mega-check"></div></div>
          </div>
          <div class="vue-chat__box" v-if="chatOpen">
            <div class="vue-chat__box__wrapper">
              <div class="vue-chat__box__header">
                <div class="vue-chat__box__avatar"><div class="vue-chat__box__avatar__image"><img src="" alt=""></div><div :class="online ? 'vue-chat__box__avatar__whatsapp' : 'vue-chat__box__avatar__whatsapp offline'"></div></div>
                <div class="vue-chat__box__name"><h4>{{ copy.name }}</h4><span v-if="state" class="vue-chat__box__state active">{{ statusText }}</span><span v-else class="vue-chat__box__state">{{ copy.typing }}</span></div>
                <button type="button" class="vue-chat__box__close" @click="close" :aria-label="copy.close"></button>
              </div>
              <div class="vue-chat__box__inner"><div class="vue-chat__box__chats"><div class="vue-chat__box__chat" v-if="chat"><div class="vue-chat__box__text">{{ chat }}</div><div class="vue-chat__box__sub"><span class="time">{{ time }}</span><div class="check"></div></div></div></div></div>
              <div class="vue-chat__box__send"><textarea v-model="message" ref="textarea" @input="adjustTextareaHeight" :placeholder="copy.placeholder"></textarea><button type="button" @click="send" :class="message.trim() ? 'vue-chat__box__submit active' : 'vue-chat__box__submit'" :disabled="!message.trim()" :aria-label="copy.send"></button></div>
            </div>
          </div>
        </div>`,
      data: {
        active: false,
        chatOpen: 0,
        messageType: "mini",
        miniMessage: 0,
        megaMessage: 0,
        state: 0,
        chat: "",
        message: "",
        time: "",
        timeMega: "",
        copy,
        online: isWithinOpeningHours()
      },
      computed: {
        statusText() { return this.online ? this.copy.online : this.copy.offline; }
      },
      watch: {
        chatOpen(open) {
          if (!open) return;
          setTimeout(() => { this.state = 1; }, 700);
          setTimeout(() => {
            this.chat = this.online ? this.copy.ready : this.copy.away;
            if (!this.time) this.time = new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
          }, 900);
        }
      },
      mounted() {
        if (!sessionStorage.getItem("vue-chat")) {
          setTimeout(() => { this.miniMessage = 1; }, 4000);
          setTimeout(() => { this.miniMessage = 0; }, 11000);
          sessionStorage.setItem("vue-chat", "1");
        }
        this.timeMega = new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
        this.active = true;
      },
      methods: {
        send() {
          const message = this.message.trim();
          if (!message) return;
          const url = `https://api.whatsapp.com/send/?phone=${whatsappNumber()}&text=${encodeURIComponent(message)}&type=phone_number&app_absent=0`;
          window.open(url, "_blank", "noopener");
          this.close();
        },
        close() { this.chatOpen = 0; },
        adjustTextareaHeight() {
          const textarea = this.$refs.textarea;
          if (!textarea) return;
          textarea.style.height = "auto";
          textarea.style.height = `${Math.max(44, textarea.scrollHeight)}px`;
        }
      }
    });
  }

  initChat();
})();
